const setScrollRestoration = (newVal) => {
	try {
		window.history.scrollRestoration = newVal;
	} catch (e) {}
};

if (process.client) {
	if ('scrollRestoration' in window.history) {
		setScrollRestoration('manual');

		// reset scrollRestoration to auto when leaving page, allowing page reload
		// and back-navigation from other pages to use the browser to restore the
		// scrolling position.
		window.addEventListener('beforeunload', () => {
			setScrollRestoration('auto');
		});

		// Setting scrollRestoration to manual again when returning to this page.
		window.addEventListener('load', () => {
			setScrollRestoration('manual');
		});
	}
}

export default (to, from, savedPosition) => {
	return new Promise((resolve) => {
		window.$nuxt.$once('triggerScroll', () => {
			if (savedPosition) {
				resolve(savedPosition);
				return;
			}
			if (to.hash) {
				let hash = to.hash;
				if (
					typeof window.CSS !== 'undefined' &&
					typeof window.CSS.escape !== 'undefined'
				) {
					hash = '#' + window.CSS.escape(hash.substr(1));
				}
				try {
					const el = document.querySelector(hash);
					if (el) {
						resolve({
							selector: hash,
							behavior: window.matchMedia(
								'(prefers-reduced-motion: reduce)'
							).matches
								? 'auto'
								: 'smooth',
						});
						return;
					}
				} catch (e) {
					// ignore
				}
			}
			// For normal navigation, scroll to top after transition
			resolve({ x: 0, y: 0 });
		});
	});
};
